export function fetchUser() {
  return window.axios.get('/user');
}

export function withdraw() {
  return window.axios.post('/withdraw');
}
